<template>
<router-view />
</template>

<script>
export default {
  name: 'PMFAnalysisVOCsRun',
  routeInfo: {
    label: 'VOCs'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/02VOCs/index.vue